export default function About() {
  return (
    <section id="about" className="py-32 bg-[#f8f9fa]">
      <div className="max-w-6xl mx-auto px-8 lg:px-16">
        <div className="flex flex-col items-center text-center space-y-8">
          <div className="inline-block">
            <span className="px-6 py-2 bg-[#06b6d4]/10 text-[#06b6d4] text-sm font-bold tracking-wider uppercase rounded-full">
              WHO WE ARE
            </span>
          </div>
          
          <h2 className="text-5xl lg:text-6xl font-bold text-[#1a2847] leading-tight max-w-4xl">
            Expert Team Behind Your Security
          </h2>
          
          <p className="text-xl text-gray-600 leading-relaxed max-w-4xl">
            BLANKA d.o.o. is a dedicated team of experts specializing in developing cutting-edge applications for the iOS platform. Our mission is to create innovative solutions that enhance user experience while prioritizing the security and privacy of mobile devices. With years of expertise in mobile development, we deliver products that users trust and rely on daily. Our flagship applications, including VPN and Cleaner, are designed with meticulous attention to detail, ensuring optimal performance and robust protection for iOS users worldwide.
          </p>
        </div>
      </div>
    </section>
  );
}